import React from 'react'
import { CheckCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const PaymentSuccessPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950 p-4">
      <div className="max-w-md w-full bg-gray-900 rounded-2xl p-8 text-center">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-white mb-2">{t('payment.success.title')}</h1>
        <p className="text-gray-400 mb-8">{t('payment.success.message')}</p>
        <button
          onClick={() => window.close()}
          className="w-full block py-3 px-6 bg-blue-600 hover:bg-blue-700 rounded-lg text-white font-medium transition-colors"
        >
          {t('payment.actions.backToMembership')}
        </button>
      </div>
    </div>
  )
}

export default PaymentSuccessPage